"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpiryPeriods = exports.ExpiryTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var ExpiryTypes = {
  hours24: 1,
  days7: 7,
  days30: 30,
  days90: 90
};
exports.ExpiryTypes = ExpiryTypes;

var getExpiryPeriods = function getExpiryPeriods(locale) {
  var _ref;

  var formatterHours = new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: 'hour',
    unitDisplay: 'long'
  });
  var formatterDays = new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: 'day',
    unitDisplay: 'long'
  });
  return _ref = {}, (0, _defineProperty2.default)(_ref, ExpiryTypes.hours24, formatterHours.format(24)), (0, _defineProperty2.default)(_ref, ExpiryTypes.days7, formatterDays.format(7)), (0, _defineProperty2.default)(_ref, ExpiryTypes.days30, formatterDays.format(30)), (0, _defineProperty2.default)(_ref, ExpiryTypes.days90, formatterDays.format(90)), _ref;
};

exports.getExpiryPeriods = getExpiryPeriods;